export const CCCD = [
    {value: 1, label: 'CMND 09 số'},
    {value: 2, label: 'CMND 12 số'},
    {value: 3, label: 'CCCD mã vạch'},
    {value: 4, label: 'CCCD gắn chip điện tử'},
];